import CryptoJS from "crypto-js";
import _ from 'lodash';
import * as moment from "moment";
import Insta_Icon from "../assets/insta-icon.svg";
import Facebook_Icon from "../assets/facebook-icon.svg";
import Youtube_Icon from "../assets/youtube-icon.svg";
import Twitter_Icon from "../assets/twitter-icon.svg";

export const maxSliderValue = 1000000;

export const phoneNumberFormat = (string) => {
  if (!string) {
    return
  }
  return string.replace(/(\d{4})(\d{3})(\d{3})/, '$1 $2 $3');
}

export const encode = (myString) => {
  try {
    const encodedWord = CryptoJS.enc.Utf8.parse(myString);
    const encoded = CryptoJS.enc.Base64.stringify(encodedWord);
    return encoded;
  } catch (error) {
    return ""
  }
}

export const decode = (encoded) => {
  try {
    const encodedWord = CryptoJS.enc.Base64.parse(encoded);
    const decoded = CryptoJS.enc.Utf8.stringify(encodedWord);
    return decoded;

  } catch (error) {
    return ""
  }
}

export const constructName = (name) => {
  const constructedName = name?.trim()?.replace(/[^a-zA-Z ]/g, " ")?.replace(/\s\s+/g, '-');
  return constructedName || ""
}

export const decryptResponse = (res) => {
  const originalResponse = CryptoJS.AES.decrypt(res, process.env.REACT_APP_API_SECRET_KEY).toString(CryptoJS.enc.Utf8);
  return JSON.parse(originalResponse);
}

export const encryptResponse = (res) => {
  var encryptResponse = CryptoJS.AES.encrypt(JSON.stringify(res), process.env.REACT_APP_API_SECRET_KEY).toString();
  return encryptResponse
}

export const duplicateValueMerge = (array) => {
  return array.map(element => {
    var result = _(element.Accounts)
      .filter(a => a.Network == 'youtube' || a.Network == 'facebook' || a.Network == 'instagram' || a.Network == 'twitter')
      .map('Network')
      .uniq()
      .map(key => ({
        key,
        NetworkUser: _(element.Accounts).find({ Network: key }).NetworkUser,
        FollowersCount: _(element.Accounts)
          .filter({ Network: key })
          .sumBy("FollowersCount"),
        SocialNetworkId: _(element.Accounts).find({ Network: key })
          .SocialNetworkId,
        Title: _(element.Accounts).find({ Network: key })
          .Title
      }))
      .value();
    element.NewAccount = element.Accounts;
    element.Accounts = result;
    return element;
  });
}

export const getYear = (assetsInstallDate) => {
  let year = 0;
  if (assetsInstallDate) {
    const enter = moment(assetsInstallDate, 'YYYY-MM-DD');
    year = moment().diff(enter, 'years', false);
  }

  return year;
}

export const tagsConcat = (interest, tags) => {
  if (tags == null && interest == null) {
    return [];
  }
  if (tags == null || tags.length == 0) {
    return interest
      .filter((item) => item?.InterestType === "category")
      .map((a) => a.InterestName);
  }
  if (interest == null || interest.length == 0) {
    return tags;
  }

  return [...tags, ...interest.map((a) => a.InterestName)];
}

export const codeConvert = (description) => {
  var x = JSON.parse('"' + description + '"')
  var r = /\\u([\d\w]{4})/gi;
  x = x.replace(r, function (match, grp) {
    return String.fromCharCode(parseInt(grp, 16));
  });
  return x
}

export const viewPublisher2 = (item) => {
  switch (item.key) {
    case "instagram":
      window.open(`https://www.instagram.com/${item.NetworkUser}`, "_blank");
      break;

    case "youtube":
      window.open(
        `https://www.youtube.com/channel/${item.SocialNetworkId}`,
        "_blank"
      );
      break;

    case "facebook":
      window.open(`https://www.facebook.com/${item.NetworkUser}`, "_blank");
      break;

    case "twitter":
      window.open(`https://www.twitter.com/${item.NetworkUser}`, "_blank");
      break;

    default:
      break;
  }
}

export const socialSection = (account, type) => {
  switch (account.key) {
    case "youtube":
      return (
        <>
          <div className='social-icon'>
            <img src={Youtube_Icon} alt="" />{" "}
          </div>
          {type === "view-details" && <p className="cursor-pointer">{account.Title}</p>}{" "}
          <span className={type === "view-details" ? "text-bold" : ""}>
            {numberConversion(account.FollowersCount || 0)}
          </span>
        </>
      );
    case "facebook":
      return (
        <>
          <div className='social-icon'>
            <img src={Facebook_Icon} alt="" />{" "}
          </div>
          {type === "view-details" && <p className="cursor-pointer">{account.Title}</p>}{" "}
          <span className={type === "view-details" ? "text-bold" : ""}>
            {numberConversion(account.FollowersCount || 0)}
          </span>
        </>
      );
    case "twitter":
      return (
        <>
          <div className='social-icon'>
            <img src={Twitter_Icon} alt="" />{" "}
          </div>
          {type === "view-details" && <p className="cursor-pointer">{account.Title}</p>}{" "}
          <span className={type === "view-details" ? "text-bold" : ""}>
            {numberConversion(account.FollowersCount || 0)}
          </span>
        </>
      );
    case "instagram":
      return (
        <>
          <div className='social-icon'>
            <img src={Insta_Icon} alt="" />{" "}
          </div>
          {type === "view-details" && <p className="cursor-pointer">{account.Title}</p>}{" "}
          <span className={type === "view-details" ? "text-bold" : ""}>
            {numberConversion(account.FollowersCount || 0)}
          </span>
        </>
      );
    default:
      return "";
  }
};

export const numberConversion = (num) => {
  if (num > 999 && num < 1000000) {
    return (num / 1000).toFixed(2) + "K"; // convert to K for number from > 1000 < 1 million
  } else if (num >= 1000000) {
    let value = (num / 1000000);
    if (value > maxSliderValue) {
      return value.toFixed(2) + "> M";
    } else {
      return value.toFixed(2) + "M"; // convert to M for number from > 1 million
    }
  } else if (num <= 999) {
    return num; // if value < 1000, nothing to do
  }
}

export const viewPublisher3 = (item) => {

  switch (item.Network) {
    case "instagram":
      window.open(`https://www.instagram.com/${item.NetworkUser}`, "_blank");
      break;

    case "youtube":
      window.open(
        `https://www.youtube.com/channel/${item.NetworkUser}`,
        "_blank"
      );
      break;

    case "facebook":
      window.open(`https://www.facebook.com/${item.NetworkUser}`, "_blank");
      break;

    case "twitter":
      window.open(`https://www.twitter.com/${item.NetworkUser}`, "_blank");
      break;

    default:
      break;
  }
};

export const socialSectionMetric = (account) => {
  switch (account.Network) {
    case "instagram":
      return (
        <>
          <div className='social-icon'><img src={Insta_Icon} alt="" /></div> <span>{account.AccountTitle}</span>
        </>
      );
    case "facebook":
      return (
        <>
          <div className='social-icon'><img src={Facebook_Icon} alt="" /></div> <span>{account.AccountTitle}</span>
        </>
      );
    case "youtube":
      return (
        <>
          <div className='social-icon'><img src={Youtube_Icon} alt="" /></div> <span>{account.AccountTitle}</span>
        </>
      );
    case "twitter":
      return (
        <>
          <div className='social-icon'><img src={Twitter_Icon} alt="" /></div> <span>{account.AccountTitle}</span>
        </>
      );
    default:
      return "";
  }
};

export const isValidUrl = urlString => {
  var a = document.createElement('a');
  a.href = urlString;
  return (a.host && a.host != window.location.host);
}

export const truncate = (source = "", size) => {
  return source?.length > size ? source?.slice(0, size) + "…" : source;
}

export const onHTMLParse = (str) => {
  let val = str.replace(/<br>/g, " ").replace(/<li>/g, " ").replace(/<ul>/g, " ")
  return val || ""
}

export const onSortAlpha = (val, key) => {
  return val.sort((a, b) => a[key].localeCompare(b[key]))
}